import fetcher, { makeFetcher } from '@sls-react/api/fetcher';
import {
  RailsItem,
  RailsThumbnailItem,
} from '@sls-react/typings/services/rails/item';
import {
  RailsFacetItemMeta,
  FlattenedFilterState,
  RailsFacetQueryOptions,
  RailsFlattenedFacetQuery,
} from '@sls-react/typings/services/rails/facets';
import { RailsFacetResponse } from '@sls-react/typings/services/rails/responses';

export const fetchUserFavorites = makeFetcher<RailsFacetResponse>(
  (page: number | string = 1, pageSize?: number | string) => [
    ({ uuid }) => `/v1/users/${uuid}/favorites`,
    {
      dataOnly: false,
      params: {
        page,
        page_size: pageSize,
        sort: 'newest',
        src: 'locker',
      },
    },
  ],
);

export const fetchMultipleItemsByIds = (itemIds: number[]) =>
  fetcher<RailsThumbnailItem[]>('/v2/facet_items', {
    params: {
      include_ids: itemIds.join(','),
      include_meta: 0,
      state: ['available'],
    },
  });

export const fetchFacetMetaNoItems = (query: FlattenedFilterState) =>
  fetcher<RailsFacetResponse>('/v2/facet_items', {
    dataOnly: false,
    params: {
      include_data: 0,
      ...query,
    },
  });

export const fetchFacetUserMeta = (
  itemIds: number[],
  additionalContext?: RailsFlattenedFacetQuery,
) =>
  fetcher<RailsFacetItemMeta[]>('/v2/facet_items/meta', {
    params: {
      ...additionalContext,
      include_ids: itemIds.join(','),
      page_size: itemIds.length,
    },
  });

export const fetchFacetItemsNoMeta = makeFetcher<RailsThumbnailItem[]>(
  (query: RailsFacetQueryOptions) => [
    '/v2/facet_items',
    {
      params: query,
    },
  ],
);

export const fetchLockerItemsMeta = makeFetcher<
  RailsFacetItemMeta[],
  [itemIds: string, username: string, pageSize: number]
>((itemIds: string, username: string, pageSize: number) => [
  '/v2/facet_items/meta',
  {
    params: {
      include_ids: itemIds,
      page_size: pageSize,
      seller: [username],
      src: 'locker',
    } as RailsFacetQueryOptions,
  },
]);

export const fetchRelatedModelItems = makeFetcher<RailsThumbnailItem[]>(
  (item: RailsItem, pageSize = 6) => [
    '/v2/facet_items',
    {
      params: {
        page_size: pageSize,
        include_meta: 0,
        model: item.model && [item.model.id],
        category: [item.categories[0].id],
        similar_to: item.id,
      } as RailsFacetQueryOptions,
    },
  ],
);

export const fetchRelatedItems = makeFetcher<
  RailsFacetResponse,
  [RailsItem] | [RailsItem, number | undefined]
>((item: RailsItem, count = 12) => [
  '/v2/facet_items',
  {
    dataOnly: false,
    params: {
      page_size: count,
      category: [item.categories[0].id],
      similar_to: item.id,
      include_meta: 0,
      sort: 'best_asc',
    } as RailsFacetQueryOptions,
  },
]);
